import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEnterpriseManage } from './EnterpriseManageContext';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { useUserAccess } from '../../context/UserAccessContext';
import { useCompaniesOptional } from '../../context/CompanyContext';
import { isPlatformAdmin } from '../../utils/platformAdmin';
import { patchEnterprise } from '../../api/enterprises';
import HubupCommunityAssignPanel from './HubupCommunityAssignPanel';

export default function EnterpriseSummaryTab() {
  const navigate = useNavigate();
  const { user, chooseAppMode } = useUserAccess();
  const companies = useCompaniesOptional();
  const platformAdmin = isPlatformAdmin(user);
  const { enterprise, setEnterprise, enterpriseId } = useEnterpriseManage();
  const [name, setName] = useState('');
  const [hubupCommunityId, setHubupCommunityId] = useState('');
  const [saving, setSaving] = useState(false);
  const [linking, setLinking] = useState(false);
  const [message, setMessage] = useState('');
  const [linkMessage, setLinkMessage] = useState('');
  const [error, setError] = useState('');
  const [linkError, setLinkError] = useState('');

  useEffect(() => {
    if (enterprise) {
      setName(enterprise.name || '');
      setHubupCommunityId(enterprise.hubupCommunityId || '');
    }
  }, [enterprise]);

  const handleLinkCommunity = async (communityId) => {
    setLinking(true);
    setLinkError('');
    setLinkMessage('');
    try {
      const res = await patchEnterprise(enterpriseId, {
        hubupCommunityId: String(communityId || '').trim(),
      });
      const ent = res?.data?.enterprise ?? enterprise;
      setEnterprise(ent);
      setHubupCommunityId(ent?.hubupCommunityId || '');
      setLinkMessage(communityId ? 'Communauté associée.' : 'Association retirée.');
    } catch (e) {
      setLinkError(e?.message || 'Impossible de modifier l’association.');
    } finally {
      setLinking(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setMessage('');
    try {
      const res = await patchEnterprise(enterpriseId, { name: name.trim() });
      setEnterprise(res?.data?.enterprise ?? enterprise);
      setMessage('Enregistré.');
      setTimeout(() => setMessage(''), 3000);
    } catch (e) {
      setError(e?.message || 'Enregistrement impossible.');
    } finally {
      setSaving(false);
    }
  };

  if (!enterprise) {
    return <p className="text-sm text-muted-foreground">Chargement…</p>;
  }

  const openCrmWorkspace = () => {
    const cid = String(enterprise.companyId || '');
    if (cid && companies?.setActiveCompanyId) {
      companies.setActiveCompanyId(cid);
    }
    chooseAppMode('crm');
    navigate('/call-performance-analytics');
  };

  return (
    <div className="space-y-5 max-w-lg">
      <div>
        <h1 className="text-lg font-semibold text-foreground">Résumé</h1>
      </div>

      <form onSubmit={handleSave} className="space-y-3">
        <Input label="Nom" value={name} onChange={(e) => setName(e.target.value)} />
        {error ? <p className="text-sm text-destructive">{error}</p> : null}
        {message ? <p className="text-sm text-emerald-600">{message}</p> : null}
        <div className="flex flex-wrap gap-2">
          <Button type="submit" size="sm" disabled={saving}>
            {saving ? '…' : 'Enregistrer'}
          </Button>
          <Button type="button" variant="outline" size="sm" onClick={openCrmWorkspace}>
            Ouvrir le CRM
          </Button>
        </div>
      </form>

      {platformAdmin ? (
        <>
          <HubupCommunityAssignPanel
            linkedCommunityId={hubupCommunityId}
            onLinkCommunity={handleLinkCommunity}
            linking={linking}
            linkError={linkError}
            linkMessage={linkMessage}
          />
        </>
      ) : null}
    </div>
  );
}
